import { ca } from '@cian/analytics';

export function trackRecommendationsToggleOn() {
  ca('eventSite', {
    action: 'CallBack_popup_toggle_recommendations_On',
    category: 'card',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackRecommendationsToggleOff() {
  ca('eventSite', {
    action: 'CallBack_popup_toggle_recommendations_Off',
    category: 'card',
    name: 'oldevent',
    useLastProducts: true,
  });
}
